import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { object, bool, string, any } from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Translation } from 'react-i18next';

const styles = (theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    width: '50%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  barLayout: {
    padding: theme.spacing(1),
  },
  progress: {
    flexGrow: 1,
    marginBottom: theme.spacing(2),
  },
});

function parseAmounts(app, quote) {
  if (app) {
    return {
      feeAmount: app.feeAmount,
      feeCurrency: app.feeCurrency,
      serviceFee: app.serviceFee || 0,
      serviceFeeCurrency: app.serviceFeeCurrency || '',
      totalAmount: app.totalAmount,
      totalAmountCurrency: app.feeCurrency,
    };
  }
  if (quote) {
    return {
      feeAmount: quote.feeAmount,
      feeCurrency: quote.feeCurrency,
      serviceFee: quote.serviceFee,
      serviceFeeCurrency: quote.serviceFeeCurrency,
      totalAmount: quote.totalSystemCur,
      totalAmountCurrency: quote.systemCurrency,
    };
  }
  return {};

  // currency(pin):"EUR"
  // systemCurrency(pin):"XOF"
  // feesPaymentCur(pin):null
  // totalPaymentCur(pin):1.08
  // totalSystemCur(pin):700
  // amountPaymentCur(pin):0.77
  // feeCurrency(pin):"XOF"
  // feeAmount(pin):500
  // addFeesPaymentCur(pin):0.31
  // addFeesSystemCur(pin):200
  // serviceFee(pin):200
  // serviceFeeCurrency(pin):"XOF"
}

const Payment = ({ classes, application, quote, fetching }) => {
  const {
    feeAmount,
    feeCurrency,
    serviceFee,
    serviceFeeCurrency,
    totalAmount,
    totalAmountCurrency,
  } = parseAmounts(application, quote);
  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <Typography
              className={classes.barLayout}
              style={{ color: '#ffffff', background: '#4CAF50' }}
              variant="subtitle1"
              align="left"
              gutterBottom
            >
              {t('paymentSubtitle')}
            </Typography>
            <Grid container alignItems="center" justifyContent="flex-start">
              <Paper className={classes.root} elevation={3}>
                {fetching && <LinearProgress className={classes.progress} />}
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Grid item xs={6}>
                    <Typography variant="subtitle1" align="left" gutterBottom>
                      {t('visaFee')}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle1" align="right" gutterBottom>
                      {`${feeAmount} ${feeCurrency}`}
                    </Typography>
                  </Grid>
                  {serviceFee > 0 && (
                    <React.Fragment>
                      <Grid item xs={6}>
                        <Typography
                          variant="subtitle1"
                          align="left"
                          gutterBottom
                        >
                          {t('serviceFee')}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="subtitle1"
                          align="right"
                          gutterBottom
                        >
                          {`${serviceFee} ${serviceFeeCurrency}`}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  )}
                </Grid>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid item xs={3}>
                    <Typography variant="h6" align="left" gutterBottom>
                      {t('totalAmount2')}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="title" align="right" gutterBottom>
                      {`${totalAmount} ${totalAmountCurrency}`}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </div>
        );
      }}
    </Translation>
  );
};

Payment.propTypes = {
  classes: object.isRequired,
  fetching: bool,
  error: string,
  amount: any,
  currency: string,
};

export default withStyles(styles)(Payment);



// WEBPACK FOOTER //
// ./src/view/forms/Application/Payment/index.js